import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import routes from './RoutesConfig';

export default function Sidebar({ show, toggle, setUser, role }) {
  const location = useLocation();
  const navigate = useNavigate(); 

  const sidebarStyle = {
    position: 'fixed',
    top: 0,
    left: show ? 0 : '-250px',
    width: '250px',
    height: '100%',
    backgroundColor: '#1e1e2f',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1600,
    transition: 'left 0.3s ease',
  };

  const overlayStyle = {
    display: show ? 'block' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 1500,
  };

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    setUser(null);
    toggle();
    navigate("/"); 
  };

  // Filtra le pagine in base al ruolo
  const menuItems = routes.filter(r => r.roles.includes(role));

  return (
    <>
      {/* Overlay */}
      <div style={overlayStyle} onClick={toggle}></div>

      {/* Sidebar */}
      <div style={sidebarStyle}>
        <h3 style={{ textAlign: 'center', color: '#00bfff', margin: '20px 0' }}>FreeSport</h3>

        <div style={{ flex: 1, overflowY: 'auto', padding: '0 10px' }}>
          <Nav className="flex-column">
            {menuItems.map(item => (
              <Nav.Link
                as={Link}
                to={item.path}
                key={item.name}
                onClick={toggle}
                style={{
                  color: location.pathname === item.path ? '#00bfff' : '#fff',
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '10px',
                  borderRadius: '8px',
                  wordBreak: 'break-word', // previene overflow su mobile
                }}
              >
                <span style={{ marginRight: '10px', display: 'flex', alignItems: 'center' }}>
                  {item.icon}
                </span>
                {item.name}
              </Nav.Link>
            ))}
          </Nav>
        </div>

        {/* Logout */}
        <div style={{ padding: '10px', flexShrink: 0 }}>
          <Button
            variant="outline-light"
            onClick={handleLogout}
            style={{ width: '100%' }}
          >
            Logout
          </Button>
        </div>
      </div>
    </>
  );
}
